import { rootApi } from '../rootApi';

export const approvalLimitGroupsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getApprovalLimitGroups: builder.query({
      query: (params) => ({
        url: 'v1/approvalmanagement/getapprovallimitgroups',
        method: 'GET',
        params: {
          IsActive: params?.IsActive,
          PageSize: params?.PageSize,
          PageNumber: params?.PageNumber,
          CreatedDate: params?.CreatedDate
        }
      }),
      transformResponse: (res) => ({
        items: res.data?.items || [],
        totalCount: res.data?.totalCount || 0,
        isSuccessful: res.isSuccessful || false
      }),
      providesTags: ['ApprovalLimitGroups']
    }),
    createApprovalLimitGroup: builder.mutation({
      query: (payload) => ({
        url: 'v1/approvalmanagement/createapprovallimitgroup',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['ApprovalLimitGroups']
    }),
    updateApprovalLimitGroup: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: 'v1/approvalmanagement/updateapprovallimitgroup',
        method: 'POST',
        body: { id, ...rest }
      }),
      invalidatesTags: ['ApprovalLimitGroups']
    }),
    getApprovalLimitGroupById: builder.query({
      query: (id) => ({
        url: 'v1/approvalmanagement/getapprovallimitgroupbyid',
        method: 'GET',
        params: { id }
      }),
      transformResponse: (res) => res.data,
      providesTags: ['ApprovalLimitGroups']
    })
  })
});

export const {
  useGetApprovalLimitGroupsQuery,
  useGetApprovalLimitGroupByIdQuery,
  useCreateApprovalLimitGroupMutation,
  useUpdateApprovalLimitGroupMutation
} = approvalLimitGroupsApi; 